















import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action} from 'vuex-class';


@Component({
    components: {BButton},
})
export default class Navbar extends Vue {
    @Prop(Boolean) public readonly showSignIn!: string;


    public BASE_URL: string;

    constructor() {
        super();
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
    }
    public goToSignIn() {
        this.$router.push({
            path: '/signin',
        });
    }

}
